import styled from 'styled-components';

import { space4XL, spaceXXL, spaceM, spaceS } from '@xing-com/tokens';

export const StyledContainer = styled.div`
  margin: calc(${spaceS} + ${spaceM}) 0
    calc(${space4XL} + ${spaceXXL} + ${spaceM});
`;
